import { isBrowser } from './environment';
let notificationSound = undefined;
const getNotificationSoundAudio = () => {
    if (!isBrowser)
        return undefined;
    if (notificationSound)
        return notificationSound;
    notificationSound = new Audio('https://conv-sdk-cdn.spotifycdn.com/new-notif.mp3');
    notificationSound === null || notificationSound === void 0 ? void 0 : notificationSound.load();
    return notificationSound;
};
export const playNotificationSound = () => {
    var _a;
    const audio = getNotificationSoundAudio();
    if (!(audio === null || audio === void 0 ? void 0 : audio.paused))
        return;
    (_a = audio === null || audio === void 0 ? void 0 : audio.play()) === null || _a === void 0 ? void 0 : _a.catch(err => {
        if (err.name !== 'NotAllowedError')
            throw err;
    });
};
